import React, { useCallback, useEffect, useState } from "react";
import Mainbackground from "../components/Mainbackground";
import { useParams } from "react-router-dom";
import axios from "axios";

function CourseDetails() {
  const path = "coursedetails";
  const { id } = useParams();
  const API_URL = process.env.REACT_APP_API_URL;
  const [courseDetails, setCourseDetails] = useState([]);
  const getCoursesById = useCallback(async () => {
    try {
      const res = await axios.get(`${API_URL}/courses/getCoursesById/${id}`);
      setCourseDetails(res.data);
    } catch (error) {
      console.error("Error fetching course details", error);
    }
  }, [id]);
  useEffect(() => {
    window.scrollTo(0, 0);
    getCoursesById();
  }, [getCoursesById]);
  const { details, title } = courseDetails;

  const renderVideoSection = () => {
    return (
      details && details.some((detail) => detail.video) && (
        <h2 className="mb-4">Videos and Explanations</h2>
      )
    );
  };

  // Render individual video with explanation
  const renderVideoDetails = (detail) => {
    return (
      detail.video && (
        <div className="card mb-3 card_cont_blog" key={detail.video}>
          <div className="row g-0">
            <div className="col-lg-4 col-md-4 col-sm-12">
              <video controls className="video_style" >
                <source src={`${API_URL}/${detail.video}`} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
            <div className="col-lg-8 col-md-8 col-sm-12">
              <div className="card-body card_body_blog">
                <div className="cont_info_blog">
                  <p className="card-title blog_title">{title}</p>
                  <div className="d-flex">
                    <i className="fa-solid fa-book card_icon ms-2 mt-1" style={{ color: "#4c74b7" }}></i>
                    <p className="details_blogs_card"></p>
                  </div>
                </div>
                <p className="card-text desc_blog" style={{maxHeight:"calc(1.2em * 9)"}}>{detail.explanation}</p>
              </div>
            </div>
          </div>
        </div>
      )
    );
  };

  // Check if details array is empty
  if (!details || details.length === 0) {
    return <p>No details available for this course.</p>;
  }
  return (
    <>
      <Mainbackground path={path} />
      {/* {courseDetails.map((course)=>( */}
      <div className="container main_cont_coursedetails" key={courseDetails.id}>
        <div className="d-flex justify-content-center">
          <img
            src={`${API_URL}/${courseDetails.image}`}
            alt="course img"
            title="course img"
            className="img_coursedetails"
          />
        </div>
        <h1 className="mt-4 mb-4">{courseDetails.title}</h1>
        <p>{courseDetails.description}</p>
        {renderVideoSection()}
        {details.map(renderVideoDetails)}
      </div>
      {/* ))} */}
    </>
  );
}

export default CourseDetails;
